import ArrearsInquiryPage from 'Feature/Arrears/components/ArrearsInquiryPage/ui/ArrearsInquiryPage';
import HbtMasterPool from 'Feature/V2/HbtMasterPool/components/HbtMasterPool';
import HbtMasterPoolDetails from 'Feature/V2/HbtMasterPool/components/HbtMasterPoolDetails';
import HbtPortfolioManagementPage from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementPage';
import HbtPortfolioManagementRequestOverview from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview';
import HbtPortfolioManagementSearchResultsPage from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementPage/pages/HbtPortfolioManagementSearchResultsPage';
import HbtMasterPoolSearchResultsPage from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/pages/HbtMasterPoolSearchResultsPage';
import HbtMasterPoolPricingScenarios from 'Feature/V2/HbtMasterPool/components/HbtMasterPool/pages/HbtMasterPoolPricingScenarios';

import { RouteConfig } from './types';

export const routePatterns = [
  '/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*',
  '/:lang([a-z]{2})/:sitecoreRoute*',
  '/:sitecoreRoute*'
];

export const staticRoutes: RouteConfig[] = [
  {
    path: [
      '/pages/portfolio-management/request-overview',
      '/en/pages/portfolio-management/request-overview',
      '/fr/pages/portfolio-management/request-overview'
    ],
    Component: HbtPortfolioManagementRequestOverview
  },
  {
    path: [
      '/pages/master-pool/master-pool-details/pricing-scenario',
      '/en/pages/master-pool/master-pool-details/pricing-scenario',
      '/fr/pages/master-pool/master-pool-details/pricing-scenario'
    ],
    Component: HbtMasterPoolPricingScenarios
  },
  {
    path: [
      '/pages/master-pool/master-pool-details',
      '/en/pages/master-pool/master-pool-details',
      '/fr/pages/master-pool/master-pool-details'
    ],
    Component: HbtMasterPoolDetails
  },
  {
    path: [
      '/pages/master-pool/search',
      '/en/pages/master-pool/search',
      '/fr/pages/master-pool/search'
    ],
    Component: HbtMasterPoolSearchResultsPage
  },
  {
    path: ['/pages/master-pool', '/en/pages/master-pool', '/fr/pages/master-pool'],
    Component: HbtMasterPool
  },
  {
    path: [
      '/pages/portfolio-management/search',
      '/en/pages/portfolio-management/search',
      '/fr/pages/portfolio-management/search'
    ],
    Component: HbtPortfolioManagementSearchResultsPage
  },
  {
    path: [
      '/pages/portfolio-management',
      '/en/pages/portfolio-management',
      '/fr/pages/portfolio-management'
    ],
    Component: HbtPortfolioManagementPage
  },
  {
    path: ['/pages/arrears/inquiry', '/en/pages/arrears/inquiry', '/fr/pages/arrears/inquiry'],
    Component: ArrearsInquiryPage
  }
];
